import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { LearningItem } from '@/models/learning-item.model';
import learningItemService from '@/services/learning-item.service';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningImportForm',
  setup(__props) {

const file = ref<File | null>(null);
const result = ref<LearningItem[]>();
const loading = ref<boolean>(false);

const valid = ref<boolean>(false);

async function importItems() {
  loading.value = true;
  if (file.value) {
    const response = await learningItemService.upload(file.value);

    result.value = response.data;

    file.value = null;
  }
  loading.value = false;
}

const fileRules = [
  (value: File) => {
    if (value) return true;

    return 'File is required';
  },
  (value: File[]) => {
    if (value && value.length && value[0].type?.indexOf('csv') !== -1) {
      return true;
    }

    return 'File must be of type CSV';
  },
];

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(importItems, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Import learning items", -1)),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    modelValue: file.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((file).value = $event)),
                    label: "CSV",
                    "filter-by-type": "text/csv",
                    rules: fileRules,
                    disabled: loading.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: "",
                    disabled: loading.value
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Import")
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (loading.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "warning"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Importing...")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_alert, { type: "info" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("p", null, [
                _createTextVNode(" The CSV can be re-uploaded, with changes, but changes to the "),
                _createElementVNode("i", null, "Link"),
                _createTextVNode(" field will not be tracked and create a "),
                _createElementVNode("strong", null, "new Learning Item"),
                _createTextVNode(". ")
              ], -1),
              _createElementVNode("p", { class: "mt-4" }, "The following columns will be used when uploading:", -1),
              _createElementVNode("ul", {
                class: "mt-4",
                style: {"padding-left":"30px"}
              }, [
                _createElementVNode("li", null, "Title"),
                _createElementVNode("li", null, "TitleNL"),
                _createElementVNode("li", null, "Description"),
                _createElementVNode("li", null, "DescriptionNL"),
                _createElementVNode("li", null, "Recommendation"),
                _createElementVNode("li", null, "RecommendationNL"),
                _createElementVNode("li", null, "Type"),
                _createElementVNode("li", null, "Category"),
                _createElementVNode("li", null, "Author"),
                _createElementVNode("li", null, "Duration"),
                _createElementVNode("li", null, "Link"),
                _createElementVNode("li", null, "Form")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})